import RestService, {ErrorDetails, RestCall, ResponseStatus} from "./restService";
import EnvironmentService from "./environmentService";
import {UserDto, BasicUserDto, GetUsersResponseDto} from "../model/functionModels";

async function getOwnUserDetails(onSuccess: (response: UserDto) => Promise<any>,
                                  onFailure: (a: string) => Promise<any>,
                                  onRedirection: (newUrl: string) => Promise<any>) {
    await RestService.doAuthenticatedCall({
            url: `${EnvironmentService.getFunctionUrl()}/users/me`,
            method: "get",
        } as RestCall,
        async (response: ResponseStatus) => {
            const dto = response.body as GetUsersResponseDto;
            const users = dto.users;
            if (users && users.length > 0) {
                await onSuccess(users[0] as UserDto);
            } else {
                await onFailure("User not found");
            }
        },
        async (_restCall: RestCall, error: ErrorDetails) => {
            console.log(`Failed getting own user details!`, error);
            await onFailure(error.error);
        },
        onRedirection);
}

async function getAllUsersList(onSuccess: (users: (UserDto | BasicUserDto)[]) => Promise<any>,
                               onFailure: (a: string) => Promise<any>,
                               onRedirection: (newUrl: string) => Promise<any>) {
    await RestService.doAuthenticatedCall({
            url: `${EnvironmentService.getFunctionUrl()}/users`,
            method: "get",
        } as RestCall,
        async (response: ResponseStatus) => {
            const dto = response.body as GetUsersResponseDto;
            await onSuccess(dto.users);
        },
        async (_restCall: RestCall, error: ErrorDetails) => {
            console.log(`Failed getting all users list!`, error);
            await onFailure(error.error);
        },
        onRedirection);
}

async function updateLocale(locale: string,
                           onSuccess: () => Promise<any>,
                           onFailure: (a: string) => Promise<any>,
                           onRedirection: (newUrl: string) => Promise<any>) {
    await RestService.doAuthenticatedCall({
            url: `${EnvironmentService.getFunctionUrl()}/users/me`,
            method: "patch",
            body: { locale },
        } as RestCall,
        async (_response: ResponseStatus) => {
            await onSuccess();
        },
        async (_restCall: RestCall, error: ErrorDetails) => {
            console.log(`Failed updating locale!`, error);
            await onFailure(error.error);
        },
        onRedirection);
}

async function updateTheme(theme: string,
                          onSuccess: () => Promise<any>,
                          onFailure: (a: string) => Promise<any>,
                          onRedirection: (newUrl: string) => Promise<any>) {
    await RestService.doAuthenticatedCall({
            url: `${EnvironmentService.getFunctionUrl()}/users/me`,
            method: "patch",
            body: { theme },
        } as RestCall,
        async (_response: ResponseStatus) => {
            await onSuccess();
        },
        async (_restCall: RestCall, error: ErrorDetails) => {
            console.log(`Failed updating theme!`, error);
            await onFailure(error.error);
        },
        onRedirection);
}

const UserDetailsService = {
    getOwnUserDetails,
    getAllUsersList,
    updateLocale,
    updateTheme,
};

export default UserDetailsService;
